export const copyPipesFromASpaceToAnotherSpace = (args) => {
    // TODO: Implement actual space-to-space pipe copy.
    // Needed behavior:
    // 1. Derive source and destination coordinate systems from the room polygons.
    // 2. Find the best rotation/mirroring match between source and destination spaces.
    // 3. Transform all routing graph node positions into the destination room.
    // 4. Rebuild edges against the transformed nodes and keep routing metadata intact.
    // 5. Validate that the transformed graph still fits the destination room and return [] if not.
    if (args.spaceToCopyFrom.polygon == null || args.spaceToCopyTo.polygon == null) {
        return [];
    }
    return args.routingGraphsToCopy.map((routingGraph) => ({
        ...routingGraph,
        roomNumber: args.spaceToCopyTo.name,
    }));
};
